// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__8QV1V","head":"Table_head__10xex","col":"Table_col__1ikI1"};